export default __webpack_public_path__ + "static/media/SampleVideo_720x480_1mb (1).e71d313b.mp4";